import {RunOutputSamplesTable} from 'lab-automation/output-samples/RunOutputSamplesTableConstants';
import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';
import {STRUCTURED_TABLE_PLUGIN} from 'notebook/structured-tables/StructuredTablePlugin';
import {Table} from 'notebook/tables/constants/TableConstants';
import {hasNLO} from 'notebook/TypePredicates';
import {Note, NoteLinkedObjectType} from 'notebook/util/NoteUtilConstants';
import {NoteLinkedAssayData} from 'runs/AttachmentConstants';
import {getOutputSamplesTablesFromVersionedData} from 'runs/NoteLinkedAssayDataUtil';
import memoizeLastCall from 'util/memoizeLastCall';

/**
 * Given a Note, we collect all RunOutputSamplesTables from inside all of the AssayRun note parts.
 * (These tables are not actually note parts themselves; they are contained within another note part.)
 *
 * The tables are converted to Table objects so they can be used in the AddSamples modal.
 */

// The list of output samples table objects is resilient to memoization. The converted tables are not!
const memoizeRunOutputSamplesTables = memoizeLastCall((...tables: Array<RunOutputSamplesTable>) => {
  const adapter = STRUCTURED_TABLE_PLUGIN.get(StructuredTableKind.RUN_OUTPUT_SAMPLES);
  return tables.map((t) => adapter.toTable(t));
});

export default function collectRunOutputSamplesTablesInNote(note: Note): Array<Table> {
  const tables: Array<RunOutputSamplesTable> = [];

  for (const notePart of note.noteParts) {
    if (hasNLO(notePart) && notePart.item.type === NoteLinkedObjectType.NOTE_LINKED_ASSAY_DATA) {
      tables.push(
        ...getOutputSamplesTablesFromVersionedData((notePart.item as NoteLinkedAssayData).versionedData)
      );
    }
  }
  return memoizeRunOutputSamplesTables(...tables);
}
